module.exports = __webpack_public_path__ + "img/logo.2570cb59.png";